import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { Resource } from '@opentelemetry/resources';
import { SEMRESATTRS_SERVICE_NAME, SEMRESATTRS_SERVICE_VERSION } from '@opentelemetry/semantic-conventions';
import { registerInstrumentations } from '@opentelemetry/instrumentation';

const formatEndpoint = (url) => {
  if (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:') {
    // Under HTTPS, direct HTTP requests to port 4318 are blocked as Mixed Content by browsers.
    // Automatically route through the Nginx reverse proxy endpoint.
    if (!url || url.startsWith('http://') || url.startsWith('/')) {
      return `${window.location.origin}/v1/traces`;
    }
  }
  if (!url) return 'http://91.203.134.93:4318/v1/traces';
  let fullUrl = url;
  if (typeof window !== 'undefined' && window.location && fullUrl.startsWith('/')) {
    fullUrl = `${window.location.origin}${fullUrl}`;
  }
  return fullUrl.endsWith('/v1/traces') ? fullUrl : `${fullUrl}/v1/traces`;
};

const rawEndpoint =
  process.env.REACT_APP_OTEL_EXPORTER_OTLP_ENDPOINT ||
  process.env.REACT_APP_VITE_OTEL_EXPORTER_ENDPOINT ||
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_OTEL_EXPORTER_ENDPOINT) ||
  process.env.VITE_OTEL_EXPORTER_ENDPOINT ||
  process.env.OTEL_EXPORTER_ENDPOINT ||
  process.env.OTEL_EXPORTER_OTLP_ENDPOINT;

const exporterEndpoint = formatEndpoint(rawEndpoint);

const orgId =
  process.env.REACT_APP_OTEL_ORG_ID ||
  process.env.OTEL_ORG_ID ||
  '5976fabc-aaf8-4995-9b89-8e41e3bc727a';
const appId =
  process.env.REACT_APP_OTEL_APP_ID ||
  process.env.OTEL_APP_ID ||
  'talent_engine';
const env =
  process.env.REACT_APP_OTEL_ENV ||
  process.env.OTEL_ENV ||
  'dev';
const serviceName =
  process.env.REACT_APP_OTEL_SERVICE_NAME ||
  process.env.OTEL_SERVICE_NAME ||
  'talent-engine-frontend';
const serviceVersion =
  process.env.REACT_APP_OTEL_SERVICE_VERSION ||
  process.env.OTEL_SERVICE_VERSION ||
  '2.14';

if (exporterEndpoint) {
  const exporter = new OTLPTraceExporter({
    url: exporterEndpoint,
  });

  const provider = new WebTracerProvider({
    resource: new Resource({
      [SEMRESATTRS_SERVICE_NAME]: serviceName,
      [SEMRESATTRS_SERVICE_VERSION]: serviceVersion,
      'deployment.environment': env,
      'service.name': serviceName,
      'service.namespace': appId,
      'service.version': serviceVersion,
      // Dual-reporting identity tags for Vigil v4
      'OTEL_SERVICE_NAME': serviceName,
      'OTEL_APP_ID': appId,
      'OTEL_ENV': env,
      'OTEL_ORG_ID': orgId,
      'vigil.org.id': orgId,
      'otel_org_id': orgId,
      'org_id': orgId,
      'app_id': appId,
      'otel_app_id': appId,
    }),
  });

  provider.addSpanProcessor(new BatchSpanProcessor(exporter));
  provider.register();

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({
        propagateTraceHeaderCorsUrls: [
          /localhost/,
          /127\.0\.0\.1/,
          /.*talentengine\.in/,
          /91\.203\.133\.211/,
          /164\.52\.203\.201/,
        ],
      }),
      new XMLHttpRequestInstrumentation({
        propagateTraceHeaderCorsUrls: [
          /localhost/,
          /127\.0\.0\.1/,
          /.*talentengine\.in/,
          /91\.203\.133\.211/,
          /164\.52\.203\.201/,
        ],
      }),
    ],
  });
}
